import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PaymentMethodsBannerWrapper = styled.div`
  padding: ${Spacing.S8} ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};
`
